import apiClient from './apiClient';
import { Patient, CreatePatientRequest, UpdatePatientRequest } from '../types/Patient';

export const patientService = {
  getAllPatients: async (): Promise<Patient[]> => {
    const response = await apiClient.get('/patients');
    return response.data;
  },

  getPatientById: async (id: number): Promise<Patient> => {
    const response = await apiClient.get(`/patients/${id}`);
    return response.data;
  },

  getPatientByEmail: async (email: string): Promise<Patient> => {
    const response = await apiClient.get(`/patients/by-email/${email}`);
    return response.data;
  },

  searchPatients: async (searchTerm: string): Promise<Patient[]> => {
    const response = await apiClient.get(`/patients?search=${encodeURIComponent(searchTerm)}`);
    return response.data;
  },

  getPatientsByAgeRange: async (minAge: number, maxAge: number): Promise<Patient[]> => {
    const response = await apiClient.get(`/patients/by-age-range?minAge=${minAge}&maxAge=${maxAge}`);
    return response.data;
  },

  createPatient: async (patient: CreatePatientRequest): Promise<Patient> => {
    // Convert empty strings to null for nullable fields
    const payload = {
      ...patient,
      dateOfBirth: patient.dateOfBirth || null,
      email: patient.email || null,
      patientAddedDate: patient.registrationDate || null,
    };
    const response = await apiClient.post('/patients', payload);
    return response.data;
  },

  updatePatient: async (id: number, patient: UpdatePatientRequest): Promise<Patient> => {
    // Convert empty strings to null for nullable fields
    const payload = {
      ...patient,
      dateOfBirth: patient.dateOfBirth || null,
      email: patient.email || null
    };
    const response = await apiClient.put(`/patients/${id}`, payload);
    return response.data;
  },

  deletePatient: async (id: number): Promise<void> => {
    await apiClient.delete(`/patients/${id}`);
  }
};